import { Icon } from "icons";
import { Tabs, TabsList, TabsTrigger } from "ui";

import { useSidebarTab } from "src/components/sidebarTabContext";
import { type SidebarTabsConfig } from "src/staticData";

interface SidebarTabsProps {
  tabs: SidebarTabsConfig;
}
export function SidebarTabs(props: SidebarTabsProps) {
  const ctx = useSidebarTab();

  return (
    <Tabs
      value={ctx.tab}
      onValueChange={(value) => {
        ctx.setTab(value);
      }}
      className="px-2 pt-2"
    >
      <TabsList
        className="grid w-full"
        style={{
          gridTemplateColumns: `repeat(${props.tabs.items.length}, minmax(0, 1fr))`,
        }}
      >
        {props.tabs.items.map((item) => {
          return (
            <TabsTrigger
              value={item.value}
              className="gap-1.5"
              key={item.value}
            >
              <Icon name={item.iconName} className="h-4 w-4" />
              <span>{item.text}</span>
            </TabsTrigger>
          );
        })}
      </TabsList>
    </Tabs>
  );
}
